import Presenter from './Presenter';
import { IContainerProps } from './types';

const FooterContainer = (props: IContainerProps) => {

    return (
        <Presenter {...props} />
    );
};

export default FooterContainer;
